export function encodeProductCode(code) {
  if (code?.includes("abc-")) {
    let numberStr = code?.toString().replace("abc-", "");
    let encodedStr = "";
    for (let char of numberStr) {
      encodedStr += (parseInt(char) + 5) % 10; // Rotate the digits
    }
    return "abc-0" + encodedStr;
  } else {
    let numberStr = code?.toString().replace("abb-", "");
    let encodedStr = "";
    for (let char of numberStr) {
      encodedStr += (parseInt(char) + 5) % 10; // Rotate the digits
    }
    return "abb-0" + encodedStr;
  }
}

export function decodeProductCode(code) {
  if (code.includes("abb-")) {
    let encodedStr = code?.toString().replace("abb-0", "");
    let decodedStr = "";
    for (let char of encodedStr) {
      decodedStr += (parseInt(char) - 5 + 10) % 10; // Reverse the rotation, +10 to handle negative values
    }
    return "abb-" + decodedStr;
  } else {
    let encodedStr = code?.toString().replace("abc-0", "");
    let decodedStr = "";
    for (let char of encodedStr) {
      decodedStr += (parseInt(char) - 5 + 10) % 10; // Reverse the rotation, +10 to handle negative values
    }
    return "abc-" + decodedStr;
  }
}

export const getSocialTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return "Just now";
  if (diff < 3600000) return Math.floor(diff / 60000) + "m";
  if (diff < 86400000) return Math.floor(diff / 3600000) + "h";
  if (diff < 604800000) return Math.floor(diff / 86400000) + "d";
  return d.toLocaleDateString();
};
